import React, { useState } from "react";
import FormModal from "./FormModal";
import "../Styles/AppointmentBtn.css";

const NavBook = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <button
        className="navBook-btn book-appointment-btn"
        onClick={() => setIsModalOpen(true)}
      >
        Book Now
      </button>
      <FormModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default NavBook;
